var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_ClaimType_form_editTitle")
        : _vm.$t("label_essweb_ClaimType_form_viewTitle"),
      widthClass: "max-1000",
      editBtn: !_vm.iSEdited,
      backgroundClass: _vm.curTab == "tab-4" ? "transparent pa-0" : "",
      pad: "0",
      initData: _vm.ClaimTypeData,
      checkData: [
        "claim_type_name",
        "claim_type_description",
        "claim_type_code",
        "claim_type_property_group_uuid",
      ],
      delBtn: "",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_ClaimType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                items: _vm.taber,
                special: _vm.curTab == "tab-4",
                contentBackground: _vm.curTab == "tab-4" ? "mrc-grey pa-0" : "",
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "pa-2",
                          attrs: { "lazy-validation": "" },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "white" },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      maxlength: "100",
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.ClaimTypeData.claim_type_name,
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.ClaimTypeData.claim_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: _vm.iSEdited ? 3 : 6 } },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      maxlength: "11",
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_sequenceLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 11]
                                      ),
                                      max: 1000,
                                      min: 0,
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_sequenceLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.ClaimTypeData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "ClaimTypeData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeCodeLabel"
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeCodeLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.ClaimTypeData.claim_type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "claim_type_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimTypeData.claim_type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_ClaimType_form_claimTypePropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.ClaimTypePorpertyGroup,
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      "item-text":
                                        "claim_type_property_group_name",
                                      "item-value": "uuid",
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_ArrRules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypePropertyGroupLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.ClaimTypeData
                                          .claim_type_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "claim_type_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimTypeData.claim_type_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.ClaimTypeData
                                          .claim_type_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.ClaimTypeData.claim_type_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.claimTypeTransactionHeaders,
                          items: _vm.claimTypeTransactions,
                          border: "",
                          showFooter: _vm.iSEdited,
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_transaction_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.code",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.claim_transaction_type_code
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                !_vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.curTranTypeUuid = item.uuid
                                            _vm.showEditTranType = true
                                          },
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "currentColor",
                                            iconClass: "viewDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.curTranTypeUuid = item.uuid
                                            _vm.showEditTranType = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDeleteTransactionType(
                                              item.uuid
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNewTranType = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addClaimTypeTransactionTypeBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.ApprovalFlowHeaders,
                          items: _vm.ApprovalFlows,
                          showFooter: _vm.iSEdited,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.amount",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.operator) +
                                        _vm._s(item.amount) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-title text--primary",
                                    attrs: {
                                      title: _vm.$getCommonLangValue(
                                        item.flow_template_name
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.flow_template_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                !_vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.curApprovalUuid = item.uuid
                                            _vm.showApprovalFlow = true
                                          },
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "currentColor",
                                            iconClass: "viewDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.curApprovalUuid = item.uuid
                                            _vm.showApprovalFlow = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.iSEdited
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDeleteApprovalFlow(
                                              item.uuid
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNewApprovalFlow = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addapprovalFlowBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-4",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "max-width rounded-lg transparent" },
                        [
                          _c(
                            "v-tabs",
                            {
                              staticClass: "mrc-grey",
                              attrs: {
                                vertical: "",
                                "background-color": "var(--taber-nav-color)",
                                "hide-slider": "",
                              },
                              model: {
                                value: _vm.lefttab,
                                callback: function ($$v) {
                                  _vm.lefttab = $$v
                                },
                                expression: "lefttab",
                              },
                            },
                            [
                              _c("v-sheet", {
                                staticClass: "rounded-t-lg",
                                attrs: { height: "8", width: "200" },
                              }),
                              _c(
                                "v-tab",
                                {
                                  staticClass:
                                    "white text-capitalize px-3 mr-2 text-left text-truncate",
                                  class:
                                    _vm.lefttab == 0
                                      ? "primary lighten-5 text--primary"
                                      : "",
                                  staticStyle: { width: "200px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "max-width text-left text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_ClaimType_form_tab_beforeNoticeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  staticClass:
                                    "white text-capitalize px-3 mr-2 text-left text-truncate",
                                  class:
                                    _vm.lefttab == 1
                                      ? "primary lighten-5 text--primary"
                                      : "",
                                  staticStyle: { width: "200px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "max-width text-left text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_ClaimType_form_tab_afterNoticeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("v-sheet", {
                                staticClass: "rounded-b-lg",
                                attrs: { height: "8", width: "200" },
                              }),
                              _c(
                                "v-tab-item",
                                { staticClass: "mrc-grey rounded-lg" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "white",
                                      attrs: { elevation: 0 },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "transparent pa-8" },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              staticClass:
                                                "mrc-grey rounded-lg",
                                              attrs: { fluid: "" },
                                            },
                                            _vm._l(
                                              _vm.beforeNoticeList,
                                              function (item, index) {
                                                return _c(
                                                  "v-sheet",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "rounded-lg pa-0 drag mt-2 mb-2",
                                                  },
                                                  [
                                                    _c("v-hover", {
                                                      attrs: {
                                                        "open-delay": "100",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var hover =
                                                                ref.hover
                                                              return [
                                                                _c(
                                                                  "v-card",
                                                                  {
                                                                    staticClass:
                                                                      "pa-2 d-flex rounded-lg align-center",
                                                                    attrs: {
                                                                      elevation:
                                                                        hover
                                                                          ? 4
                                                                          : 2,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "grey",
                                                                          iconClass:
                                                                            "dragvertical",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "black",
                                                                          iconClass:
                                                                            "arrow01",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                item[
                                                                                  "claim_type_notice_point_" +
                                                                                    item.number
                                                                                ]
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-spacer"
                                                                    ),
                                                                    hover &&
                                                                    _vm.iSEdited
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toEditNotice(
                                                                                    item,
                                                                                    "before"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "edit"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    hover &&
                                                                    _vm.iSEdited
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onDeleteNotice(
                                                                                    item.number,
                                                                                    "before"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "delete"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form2",
                                              attrs: { "lazy-validation": "" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          disabled:
                                                            !_vm.iSEdited,
                                                          label: _vm.$t(
                                                            "label_essweb_ClaimType_form_noticeRequireLabel"
                                                          ),
                                                          required: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.before_is_required_acknowledgement,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.before_is_required_acknowledgement =
                                                              $$v
                                                          },
                                                          expression:
                                                            "before_is_required_acknowledgement",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "inputTextFiledMultiLang",
                                                        {
                                                          attrs: {
                                                            filled:
                                                              _vm.iSEdited,
                                                            readonly:
                                                              !_vm.iSEdited,
                                                            maxlength: "100",
                                                            bindData:
                                                              _vm.before_acknowledge,
                                                            label: _vm.$t(
                                                              "label_essweb_ClaimType_form_acknowledgeLabel"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              valueArr
                                                            ) {
                                                              _vm.before_acknowledge =
                                                                valueArr
                                                            },
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { staticClass: "mrc-grey" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "white",
                                      attrs: { elevation: 0 },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "transparent pa-8" },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              staticClass:
                                                "mrc-grey rounded-lg",
                                              attrs: { fluid: "" },
                                            },
                                            _vm._l(
                                              _vm.afterNoticeList,
                                              function (item, index) {
                                                return _c(
                                                  "v-sheet",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "rounded-lg pa-0 drag mt-2 mb-2",
                                                  },
                                                  [
                                                    _c("v-hover", {
                                                      attrs: {
                                                        "open-delay": "100",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var hover =
                                                                ref.hover
                                                              return [
                                                                _c(
                                                                  "v-card",
                                                                  {
                                                                    staticClass:
                                                                      "pa-2 d-flex rounded-lg align-center",
                                                                    attrs: {
                                                                      elevation:
                                                                        hover
                                                                          ? 4
                                                                          : 2,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "grey",
                                                                          iconClass:
                                                                            "dragvertical",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "black",
                                                                          iconClass:
                                                                            "arrow01",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                item[
                                                                                  "claim_type_notice_point_" +
                                                                                    item.number
                                                                                ]
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-spacer"
                                                                    ),
                                                                    hover &&
                                                                    _vm.iSEdited
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toEditNotice(
                                                                                    item,
                                                                                    "after"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "edit"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    hover &&
                                                                    _vm.iSEdited
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onDeleteNotice(
                                                                                    item.number,
                                                                                    "after"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "delete"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form3",
                                              attrs: { "lazy-validation": "" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          disabled:
                                                            !_vm.iSEdited,
                                                          label: _vm.$t(
                                                            "label_essweb_ClaimType_form_noticeRequireLabel"
                                                          ),
                                                          required: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.after_is_required_acknowledgement,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.after_is_required_acknowledgement =
                                                              $$v
                                                          },
                                                          expression:
                                                            "after_is_required_acknowledgement",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "inputTextFiledMultiLang",
                                                        {
                                                          attrs: {
                                                            filled:
                                                              _vm.iSEdited,
                                                            readonly:
                                                              !_vm.iSEdited,
                                                            bindData:
                                                              _vm.after_acknowledge,
                                                            rules:
                                                              _vm.$GetRules(
                                                                [
                                                                  "_Require_Rules",
                                                                ],
                                                                [null]
                                                              ),
                                                            label: _vm.$t(
                                                              "label_essweb_ClaimType_form_acknowledgeLabel"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              valueArr
                                                            ) {
                                                              _vm.after_acknowledge =
                                                                valueArr
                                                            },
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-5",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.claimTypeItemHeaders,
                          items: _vm.claimTypeItems,
                          border: "",
                          showFooter: _vm.iSEdited,
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toDeleteClaimItem(item.uuid)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.newClaimItemDialog = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addClaimItemBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited &&
            _vm.curTab != "tab-5" &&
            _vm.curTab != "tab-3" &&
            _vm.curTab != "tab-2"
              ? _c("CardActions", {
                  style: {
                    marginLeft: _vm.curTab == "tab-4" ? "208px" : "0px",
                    width:
                      _vm.curTab == "tab-4" ? "calc(100% - 208px)" : "100%",
                  },
                  attrs: {
                    saveBtn:
                      _vm.iSEdited &&
                      (_vm.curTab == "tab-1" || _vm.curTab == "tab-4"),
                  },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("editClaimTransactionType", {
              attrs: {
                show: _vm.showEditTranType,
                iSEdited: _vm.iSEdited,
                curUuid: _vm.curTranTypeUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showEditTranType = false
                  _vm.curTranTypeUuid = null
                },
                onSave: _vm.onSaveTransactionType,
              },
            }),
            _c("newClaimTransactionType", {
              attrs: { show: _vm.showNewTranType },
              on: {
                close: function ($event) {
                  _vm.showNewTranType = false
                },
                onNew: _vm.onNewTransactionType,
              },
            }),
            _c("editApprovalFlow", {
              attrs: {
                show: _vm.showApprovalFlow,
                iSEdited: _vm.iSEdited,
                curUuid: _vm.curApprovalUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showApprovalFlow = false
                  _vm.curApprovalUuid = null
                },
                onSave: _vm.onSaveApprovalFlow,
              },
            }),
            _c("newApprovalFlow", {
              attrs: { show: _vm.showNewApprovalFlow },
              on: {
                close: function ($event) {
                  _vm.showNewApprovalFlow = false
                },
                onNew: _vm.onNewApprovalFlow,
              },
            }),
            _c("newNotice", {
              attrs: {
                show: _vm.showNewNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showNewNotice = false
                  _vm.NoticePropertyData = null
                },
                onNew: _vm.onNewNotice,
              },
            }),
            _c("newClaimItem", {
              attrs: {
                show: _vm.newClaimItemDialog,
                PorpertyData: _vm.curSelectClaimItem,
              },
              on: {
                close: function ($event) {
                  _vm.newClaimItemDialog = false
                },
                onSave: _vm.onEditClaimItem,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }